<div class="row title-bar">
  <div class="col-6">
    <h6 class="page-header">Build steps to create timeline</h6>
  </div>
  <div class="col-6">
    <div class="float-right">
      <p class="move-to-label">{{ selectedObjArray && selectedObjArray.length > 0 ?
        selectedObjArray.length : 0 }} fields selected</p>
      <button type="submit"
        [ngClass]="{'vdBuildBtn-disbaled': !selectedObjArray || (selectedObjArray && selectedObjArray.length === 0)}"
        [disabled]="!selectedObjArray || (selectedObjArray && selectedObjArray.length === 0)" class="vdBuildBtn mr-3"
        (click)="moveToStep()">MOVE TO NEW STEP</button>
      <button type="submit"
        [ngClass]="{'vdBuildBtn-disbaled': !selectedObjArray || (selectedObjArray && selectedObjArray.length === 0)}"
        [disabled]="!selectedObjArray || (selectedObjArray && selectedObjArray.length === 0)" class="vdBuildBtn"
        (click)="previewStep()">PREVIEW</button>
    </div>
  </div>
</div>
<div class="row build-steps-content-div mb-5">
  <div class="col-12 build-steps-scrollable">
    <div class="uploaded-file-list" *ngIf="pdfList && pdfList.length > 0">
      <p-table [value]="pdfList" [reorderableColumns]="true" responsiveLayout="scroll">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th scope="col">
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file let-index="rowIndex">
          <tr [pReorderableRow]="index">
            <td>
              <p-accordion>
                <p-accordionTab [header]="file.fileName">
                  <div class="pt-3">
                    <div class="row">
                      <div class="col-9"></div>
                      <div class="col-3">
                        <div class="row">
                          <div class="col-6">
                            <div class="form-group">
                              <label class="d-block">Row Number</label>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <label class="d-block">Width</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row" *ngFor="let element of file.elementList; let i = index;">
                      <div class="col-9 pb-4">
                        <div class="disabled-element" *ngIf="element.disabled"></div>
                        <div class="row">
                          <div class="col-1 pr-0">
                            <p-checkbox name="pdfObj" [(ngModel)]="element.checked" [binary]="true"
                              (onChange)="onChecked(element)"></p-checkbox>
                          </div>
                          <div class="col-11 pl-0">
                            <div [ngSwitch]="element.fieldType">
                              <div *ngSwitchCase="'partTitle'">
                                <span class="part-title">{{ element.elementTitle }}</span>
                              </div>
                              <div *ngSwitchCase="'subHeadingTitle'">
                                <span class="sub-head-title">{{ element.elementTitle }}</span>
                              </div>
                              <div *ngSwitchCase="'Questionnaire'">
                                <div class="form-group clearfix">
                                  <label class="questionnaire-lbl">{{ element.elementTitle }}</label>
                                  <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                                </div>
                              </div>
                              <div *ngSwitchCase="'switchWithExp'">
                                <div class="form-group clearfix">
                                  <label class="questionnaire-lbl">{{ element.elementTitle }}</label>
                                  <p-inputSwitch styleClass="questionnaire-switch" class="float-left"></p-inputSwitch>
                                </div>
                                <div class="form-group">
                                  <label class="d-block">{{ element.textAreaLabel }}</label>
                                  <textarea class="json-viewer-textarea" [disabled]="true" pInputTextarea></textarea>
                                </div>
                              </div>
                              <div *ngSwitchCase="'textarea'">
                                <div class="form-group">
                                  <label class="d-block">{{ element.elementTitle }}</label>
                                  <textarea class="json-viewer-textarea" pInputTextarea></textarea>
                                </div>
                              </div>
                              <div *ngSwitchCase="'Textbox'">
                                <div class="form-group">
                                  <label class="d-block">{{ element.elementTitle }}</label>
                                  <input type="text" pInputText />
                                </div>
                              </div>
                              <div *ngSwitchCase="'checkboxWithHeader'">
                                <div class="form-group">
                                  <label class="d-block"
                                    *ngIf="element.elementTitle && element.elementTitle.length > 0">{{
                                    element.elementTitle }}</label>
                                  <div class="clearfix">
                                    <p-checkbox class="pdf-checkbox" *ngFor="let props of element.properties"
                                      [label]="props.name">
                                    </p-checkbox>
                                  </div>
                                </div>
                              </div>
                              <div *ngSwitchCase="'Checkbox'">
                                <div class="form-group clearfix">
                                  <p-checkbox class="pdf-checkbox" *ngFor="let props of element.properties"
                                    [label]="props.name">
                                  </p-checkbox>
                                </div>
                              </div>
                              <div *ngSwitchCase="'elementHeading'">
                                <span class="element-head-title">{{ element.elementTitle }}</span>
                              </div>
                              <div *ngSwitchCase="'Dropdown'">
                                <div class="form-group">
                                  <label class="d-block">{{ element.elementTitle }}</label>
                                  <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="element.properties">
                                  </p-dropdown>
                                </div>
                              </div>
                              <div *ngSwitchCase="'CALENDAR'">
                                <div class="form-group">
                                  <label class="d-block">{{ element.elementTitle }}</label>
                                  <p-calendar appendTo="body" styleClass="vd-pdf-datepicker" dateFormat="mm/dd/yy"
                                    placeholder="MM/DD/YYYY" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
                                  </p-calendar>
                                </div>
                              </div>
                              <div *ngSwitchCase="'Radiobutton'">
                                <div class="form-group">
                                  <label class="d-block"
                                    *ngIf="element.elementTitle && element.elementTitle.length > 0">{{
                                    element.elementTitle }}</label>
                                  <div class="clearfix">
                                    <p-radioButton class="mb-2 pdf-radiobutton"
                                      *ngFor="let props of element.properties; let y = index;"
                                      [(ngModel)]="element.radioValue" [value]="element.groupName + '_' + y"
                                      [label]="props.name"></p-radioButton>
                                  </div>
                                </div>
                              </div>
                              <div *ngSwitchCase="'countryState'">
                                <div class="row">
                                  <div class="col-4">
                                    <div class="form-group">
                                      <label class="d-block">Country</label>
                                      <p-dropdown appendTo="body" styleClass="pdf-dropdown" [options]="countryList"
                                        optionLabel="name" optionValue="code" (onChange)="handleCountryChange($event, element)">
                                      </p-dropdown>
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="form-group">
                                      <label class="d-block">State</label>
                                      <input type="text"
                                        *ngIf="!element.stateList || (element.stateList && element.stateList.length === 0)"
                                        pInputText class="json-viewer-input" placeholder="Enter" />
                                      <p-dropdown appendTo="body" *ngIf="element.stateList && element.stateList.length > 0"
                                        optionLabel="stateProvinceName" optionValue="stateProvinceCode"
                                        styleClass="pdf-dropdown" [options]="element.stateList">
                                      </p-dropdown>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div *ngSwitchDefault>
                                <span style="font-weight:600;color:red;">Default</span> {{
                                element.fieldType }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-3 pb-4">
                        <div class="disabled-element" *ngIf="element.disabled"></div>
                        <div class="row">
                          <div class="col-6">
                            <div class="form-group">
                              <p-inputNumber placeholder="Enter" [(ngModel)]="element.numberOfRow" [useGrouping]="false"
                                [min]="1">
                              </p-inputNumber>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <p-dropdown appendTo="body" class="w-100" [options]="columnWidth"
                                [(ngModel)]="element.numberOfColumn" optionValue="value" optionLabel="label">
                              </p-dropdown>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </p-accordionTab>
              </p-accordion>
              <span class="pi pi-bars" pReorderableRowHandle></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-divider type="dashed" class="vd-build-steps"></p-divider>
<div class="row mt-5">
  <div class="col-12">
    <div class="float-right">
      <button type="submit" class="btn vdCreateBtn" (click)="nextStep()">NEXT</button>
    </div>
  </div>
</div>
